import { isEmpty } from '@intelligence/v3/utils/common';
import { resolveApiField } from '../shared/fieldMapUtils';
import { StringArrayMiddlewareUtils } from '../shared/middlewareUtils';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';

/**
 * 公司筛选器中间件工具
 * value 类型：string[]
 */
class CompanySelectMiddlewareUtils extends StringArrayMiddlewareUtils {
  convertToApiParams(item: IFilterItemConfig, filterValue?: string[], params?: unknown): IRecord<string[]> | null {
    if (!isEmpty(filterValue)) {
      return super.convertToApiParams(item, filterValue, params);
    }

    const field = resolveApiField(item, undefined, params);

    if (isEmpty(field)) {
      return null;
    }

    return {
      [field]: [],
    };
  }
}

export default CompanySelectMiddlewareUtils;
